export default "__VITE_ASSET__CTGCaukE__"